import * as React from 'react'
import { IconsModel } from '../types/iconsModel'

const SvgJardinPrivatif = (
	{
		color,
		width = 45,
		height = 35
	}: IconsModel
) => (
	<svg
		id="jardinPrivatif_svg__FULL_VECTO_SEUL"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 425.2 425.2"
		width={width}
		height={height}
	>
		<defs>
			<style>{`.prestation_cls_fill{fill:${color}`}</style>
		</defs>
		<path
			className="prestation_cls_fill"
			d="M153.85 151.25c0-36.07-18.41-67.97-45.8-79.38l-1.93-.8-1.93.8c-27.4 11.41-45.8 43.31-45.8 79.38s17.14 65.73 42.96 78.1v103.42h10.05V229.1c25.54-12.54 42.46-43.27 42.46-77.85Zm-42.46 66.39v-77.07h-10.05v77.38c-19.95-12.01-32.92-37.76-32.92-66.7 0-31.19 15.06-58.69 37.69-69.26 22.63 10.56 37.69 38.07 37.69 69.26 0 28.69-12.75 54.26-32.41 66.39ZM366.82 308.63l-20.51-30.77v-56.89h-180.9v56.89l-20.51 30.77 4.18 7.81h16.33v37.69h10.05v-37.69h160.8v37.69h10.05v-37.69h16.33l4.18-7.81Zm-30.56-77.61v43.34h-160.8v-43.34h160.8Zm-177.8 75.38 14.66-21.99h165.47l14.66 21.99H158.46ZM245.18 166.95c14.41 0 27.35 8.03 33.77 20.95l3.66 7.37 4.88-6.62c5.08-6.9 13.21-11.01 21.76-11.01 14.89 0 27.01 12.12 27.01 27.01h10.05c0-20.43-16.62-37.06-37.06-37.06-9.27 0-18.19 3.53-24.96 9.68-8.85-12.71-23.28-20.36-39.11-20.36-26.32 0-47.73 21.41-47.73 47.73h10.05c0-20.78 16.91-37.69 37.69-37.69Z"
		/>
	</svg>
)
export default SvgJardinPrivatif
